import { render, staticRenderFns } from "./DetailsPaneDesign.vue?vue&type=template&id=01d4f83e"
import script from "./DetailsPaneDesign.vue?vue&type=script&lang=ts"
export * from "./DetailsPaneDesign.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports